import { InputStyles, } from '@awaze/design-system.components.input';
import { pxToRems } from '@awaze/design-system.utils.react';
import styled, { css } from 'styled-components';
const getColouredArrowDown = (props) => {
    const { arrowColour } = props;
    const colourHex = arrowColour ? arrowColour.replace('#', '') : '666666';
    return `data:image/svg+xml,%3Csvg width='13' height='7' viewBox='0 0 13 7' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.4561 0.345032C12.5461 0.555051 12.4936 0.795073 12.3361 0.960089L7.15311 6.14307C6.9806 6.31558 6.74808 6.41309 6.50055 6.41309C6.25303 6.41309 6.02051 6.31558 5.84799 6.14307L0.665015 0.960089C0.560006 0.855079 0.5 0.705065 0.5 0.562552C0.5 0.487545 0.515001 0.420039 0.545004 0.345032C0.627512 0.135012 0.837531 0 1.06255 0H11.9386C12.1636 0 12.3736 0.135012 12.4561 0.345032Z' fill='%23${colourHex}' /%3E%3C/svg%3E`;
};
export const SelectContainerStyled = styled.div `
  position: relative;
`;
export const SelectStyled = styled.select `
  ${InputStyles};

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  padding-right: ${pxToRems(18)};

  ${({ placeholderActive, theme }) => placeholderActive &&
    css `
      color: ${theme.ColorGrey400};

      option {
        color: ${theme.ColorGrey900};
      }
    `}

  background-image: url("${(props) => getColouredArrowDown(props)}");
  background-position-x: calc(100% - 18px);
  background-position-y: 50%;
  background-repeat: no-repeat;
  appearance: none;
`;
export const SelectTextStyled = styled.span `
  overflow: hidden;
  padding-right: ${pxToRems(8)};
  text-overflow: ellipsis;
  white-space: nowrap;
`;
//# sourceMappingURL=select.styles.js.map